import { dispatch, openUrl } from '@btcdirect/functions';
import { useApiCommunicator } from '@btcdirect/shared/src/composables/api/communicator';
import { Endpoints } from '@btcdirect/shared/src/composables/api/endpoints';
import { useConfiguration } from '@btcdirect/shared/src/composables/configuration';
import { useIdentifier } from '@btcdirect/shared/src/composables/util/identifier';
import { useLocale } from '@btcdirect/shared/src/composables/util/locale';
import { DispatchEvents } from '@btcdirect/shared/src/types';
import { useAuthenticationStore } from '@btcdirect/stores';

interface RegisterIdentifierResponse {
    redirectUrl: {
        [key: string]: string;
    };
}

const { post } = useApiCommunicator(Endpoints.REGISTER_IDENTIFIER);

const { returnUrl } = useConfiguration();

export const useRegisterIdentifier = () => {
    const authenticationStore = useAuthenticationStore();

    const registerIdentifier = async (redirect: boolean = true): Promise<void> => {
        const identifier = useIdentifier().create();

        try {
            const result = (await post({
                identifier: identifier,
                returnUrl: returnUrl.value
            })) as RegisterIdentifierResponse;

            authenticationStore.setUserTokens({ identifier: identifier });

            dispatch(DispatchEvents.IDENTIFIED, {
                user: identifier,
                identifier: identifier
            });

            if (!redirect) {
                return;
            }

            const { locale, fallback } = useLocale();

            // TODO: Check if this should depend on the "open new tab"-setting
            openUrl(result.redirectUrl[locale.value] || result.redirectUrl[fallback.value]);
        } catch (exception) {
            return Promise.reject('An error occurred when trying to register a new identifier: ' + exception);
        }
    };

    return {
        registerIdentifier
    };
};
